function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-Organizations",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13,0 C14.0543618,0 14.9181651,0.815877791 14.9945143,1.85073766 L15,2 L15,12 L20,12 C21.0543618,12 21.9181651,12.8158778 21.9945143,13.8507377 L22,14 L22,24 L2,24 L2,2 C2,0.945638205 2.81587779,0.0818348781 3.85073766,0.00548573643 L4,0 L13,0 Z M13,2 L4,2 L4,22 L8,22 L8,14 C8,12.9456382 8.81587779,12.0818349 9.85073766,12.0054857 L10,12 L13,12 L13,2 Z M20,14 L10,14 L10,22 L13,22 L13,18 C13,17.4477153 13.4477153,17 14,17 L16,17 C16.5522847,17 17,17.4477153 17,18 L17,22 L20,22 L20,14 Z M10,8 C10.5522847,8 11,8.44771525 11,9 C11,9.51283584 10.6139598,9.93550716 10.1166211,9.99327227 L10,10 L7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.48716416 6.38604019,8.06449284 6.88337887,8.00672773 L7,8 L10,8 Z M10,4 C10.5522847,4 11,4.44771525 11,5 C11,5.51283584 10.6139598,5.93550716 10.1166211,5.99327227 L10,6 L7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.48716416 6.38604019,4.06449284 6.88337887,4.00672773 L7,4 L10,4 Z",
  id: "Combined-Shape",
  fill: "#60CAA8",
  fillRule: "nonzero"
}));

var SvgOrganization = function SvgOrganization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/organization.f5061ce3.svg";
export { ForwardRef as ReactComponent };